class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.isHovering = false;
    
    // 仅在桌面端启用 hover 功能
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.setupHoverBehavior();
    }
  }

  setupHoverBehavior() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    
    // 检查是否为桌面端
    const isDesktop = () => window.innerWidth >= 990;
    
    // 鼠标进入时打开
    this.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      this.isHovering = true;
      clearTimeout(this.hoverTimeout);
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    // 鼠标离开时延迟关闭
    this.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      this.isHovering = false;
      this.hoverTimeout = setTimeout(() => {
        if (!this.isHovering && !this.contains(document.activeElement)) {
          this.close();
        }
      }, 200); // 200ms 延迟，避免快速移动时关闭
    });

    // 鼠标在内容区域时保持打开
    if (content) {
      content.addEventListener('mouseenter', () => {
        if (isDesktop()) {
          clearTimeout(this.hoverTimeout);
        }
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    // 当菜单关闭时，重置所有菜单项的动画状态
    if (!this.mainDetailsToggle.open) {
      const menuItems = this.mainDetailsToggle.querySelectorAll('.mega-menu__list > li');
      const subTitles = this.mainDetailsToggle.querySelectorAll('.mega-menu__secondary__title');
      const subItems = this.mainDetailsToggle.querySelectorAll('.mega-menu__list > li .list-unstyled > li');
      
      // 强制重置动画，确保下次打开时能重新触发
      [menuItems, subTitles, subItems].forEach(elements => {
        elements.forEach(el => {
          el.style.animation = 'none';
          // 使用 requestAnimationFrame 确保浏览器重新计算样式
          requestAnimationFrame(() => {
            el.style.animation = '';
          });
        });
      });
    }
  }
}

customElements.define('header-menu', HeaderMenu);
